export function gameRuleGeneratedDocumentStatusLabel(status: string): string {
  const normalized = status.trim().toLowerCase();
  if (normalized === "review") return "Pending Review";
  if (normalized === "approved") return "Approved";
  if (normalized === "draft") return "Draft";
  return status;
}

export function gameRuleGeneratedDocumentStatusBadgeClass(status: string): string {
  const normalized = status.trim().toLowerCase();
  if (normalized === "approved") {
    return "bg-emerald-50 border-emerald-200 text-emerald-700";
  }
  if (normalized === "review") {
    return "bg-amber-50 border-amber-200 text-amber-800";
  }
  if (normalized === "draft") {
    return "bg-gray-50 border-gray-200 text-gray-700";
  }
  if (normalized.includes("fail") || normalized.includes("error")) {
    return "bg-red-50 border-red-200 text-red-700";
  }
  return "bg-sky-50 border-sky-200 text-sky-700";
}
